module.exports = __webpack_public_path__ + "static/media/import-linked-in-instruction.0ba2852f.png";